import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const { username, accessToken } = JSON.parse(storedUser);
      setUser({ username });
      setAccessToken(accessToken);
    }
  }, []);

  const login = async (username, password) => {
    try {
      const response = await fetch("https://api.onacademyon.com/staff/signin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
        // credentials: "include",
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      console.log(data)

      setUser({ username });
      setAccessToken(data.accessToken);
      localStorage.setItem("user", JSON.stringify({ username,refreshToken:data.refreshToken, accessToken: data.accessToken }));
    } catch (error) {
      console.error("❌ Login error:", error.message);
    }
  };

  const logout = async () => {
    // await fetch("http://localhost:5000/api/logout", { method: "POST", credentials: "include" });
    setUser(null);
    setAccessToken(null);
    localStorage.removeItem("user");
  };

  const refreshAccessToken = async () => {
    try {
      const response = await fetch("https://api.onacademyon.com/staff/authenticate", {
        method: "POST",
        refreshToken: JSON.parse(localStorage.getItem("user")).refreshToken,
        // credentials: "include",
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error);

      setAccessToken(data.accessToken);
      localStorage.setItem("user", JSON.stringify({ username: user.username, accessToken: data.accessToken }));
    } catch (error) {
      console.error("❌ Refresh token error:", error.message);
    }
  };

  return (
    <AuthContext.Provider value={{ user, accessToken, login, logout, refreshAccessToken }}>
      {children}
    </AuthContext.Provider>
  );
};
